import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  accordion: {
    "& .MuiCollapse-container": {
      padding: 8,
      margin: -8
    },
    paddingBottom: 10,
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      paddingBottom: 0
    }
  },
  emptyDataHolder: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#c3c3c3",
    fontSize: 14
  },
  accordionContent: {
    width: "100%"
  },
  tableWrapper: {
    position: "relative"
  },
  tableContainer: {
    borderBottom: "1px solid #eeeeee",
    [theme.breakpoints.up("md")]: {
      flex: "auto"
    }
  },
  table: {
    lineHeight: 1,
    color: theme.palette.text.secondary
  },
  scratchRow: {
    height: 36
  },
  scratchCell: {
    padding: "0 16px",
    lineHeight: "normal",
    fontSize: 14,
    width: "60%",
    fontFamily: "SuisseIntlRegular",
    minWidth: 130,
    "&:first-child": {
      width: "40%"
    }
  },
  tableHead: {
    color: theme.palette.text.primary,
    height: 36
  },
  tableHeadCell: {
    height: 36,
    padding: "4px 0",
    fontSize: 14,
    width: "60%",
    paddingLeft: 16,
    paddingRight: 16,
    fontFamily: "SuisseIntlMedium",
    minWidth: 146,
    "&:first-child": {
      width: "40%"
    }
  },
  slideLoader: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  }
}));
